import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { setChatVisible, setNativeChatVisible } from 'features/chat/chatSlice';
import { useCurrentEvent } from 'features/events/eventHooks';
import { IconButton } from 'components/Buttons/IconButton';
import { useNativeEvents } from 'hooks/useNativeEvents';
import { useNativefullScreenChat } from '../chatHooks';
import { useMediaQuery } from 'react-responsive';
import { useSocialElementsDisabled } from 'features/channel/channelHooks';

interface ChatButtonProps {
  isDisabled?: boolean;
}

export const ChatButton: FunctionComponent<ChatButtonProps> = (props) => {
  const chatVisible = useSelector((state: RootState) => state.chat.isVisible);
  const nativeChatVisible = useSelector(
    (state: RootState) => state.chat.isNativeChatVisible
  );
  const dispatch = useDispatch();
  const event = useCurrentEvent();
  const hasNewComments = useSelector(
    (state: RootState) => state.chat.hasNewComments
  );
  const { postMessage } = useNativeEvents();
  const socialElementsDisabled = useSocialElementsDisabled();
  const nativefullScreenChat = useNativefullScreenChat();
  const isMobile = useMediaQuery({ query: '(max-width: 739px)' });

  const selectIcon = (): string => {
    if (chatVisible) {
      return 'chatClose';
    } else {
      return 'chatOn';
    }
  };
  const label = props.isDisabled ? 'Chat disabled' : 'Chat now';

  useEffect(() => {
    postMessage({
      chatVisible: chatVisible
    });
  }, [chatVisible, postMessage]);

  if (socialElementsDisabled) {
    return null;
  }

  if (event && !event.chatEnabled) {
    return null;
  }

  return (
    <IconButton
      ariaExpanded={chatVisible}
      label={label}
      onClick={() => {
        if (nativefullScreenChat && isMobile) {
          window.location.href = `channel://chat?url=${
            window.location.protocol + '//' + window.location.host + '/chat'
          }`;
          dispatch(setNativeChatVisible(!nativeChatVisible));
        } else {
          dispatch(setChatVisible(!chatVisible));
        }
      }}
      isDisabled={props.isDisabled}
      icon={selectIcon()}
      showNotification={(!chatVisible || !nativeChatVisible) && hasNewComments}
    />
  );
};
